import { Level, SummaryArticle, useBook, useIntl } from '@topwrite/common';
import useArticle from '@/lib/use-article';
import Link from '@/components/link';

interface Props {
    className?: string;
}

export default function Breadcrumb({ className }: Props) {
    const { summary } = useBook();
    const article = useArticle();
    const intl = useIntl();
    const children = [
        <li key='0'><Link to={'.'}>{intl.formatMessage({
            defaultMessage: '首页'
        })}</Link></li>
    ];

    if (article) {
        const level = article.getLevel();
        level.data.reduce<number[]>((prev, i) => {
            prev.push(i);
            const itemLevel = new Level(prev);
            const item = summary.getByLevel(itemLevel);
            if (item) {
                if (item instanceof SummaryArticle && !itemLevel.eq(level)) {
                    children.push(
                        <li key={itemLevel.toString()}><Link to={item} /></li>
                    );
                } else if (item.title) {
                    children.push(
                        <li key={itemLevel.toString()}>{item.title}</li>
                    );
                }
            }
            return prev;
        }, []);
    }

    return <ol className={className}>
        {children}
    </ol>;
}
